/**
 * author: Soumya Shhreyas
 * Suppliers Pending invitations from companies
 */
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import "./PendingInvitations.scss";
import { withTranslation } from "react-i18next";
import { CgSortAz } from "react-icons/cg";
import { Link, useNavigate } from "react-router-dom";
import { FcFinePrint } from "react-icons/fc";

import { Table, Badge, Form, Dropdown, Button } from "react-bootstrap";
import moment from "moment";
// import Logo from '../../../images/Share_folder.png';
import Breadcrumb from "react-bootstrap/Breadcrumb";
import InvitationService from "../../../core/service/InvitationService";
import Pagination from "../../../components/Pagination/Pagination";
import {
  DEFAULT_ITEMS_PER_PAGE,
  SORT_ORDER_DESC,
  LIST_DEF_SORT,
  STATUS,
} from "../../../core/constants/common";
import nodataimg from "../../../images/nodatafound.png";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";

const PendingInvitations = ({ t }) => {
  const [invitations, SetInvitations] = useState([]);
  const [itemsTotalCount, setItemTotalCount] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(DEFAULT_ITEMS_PER_PAGE);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchKey, setSearchKey] = useState("");
  const [order, setOrder] = useState(SORT_ORDER_DESC);
  const [sortField, setSortField] = useState(LIST_DEF_SORT);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selItem, setSelItem] = useState("");
  const navigate = useNavigate();
  let messageConfirmation = t("IgnoreInvitationConfirmation.label");
  useEffect(() => {
    let data = JSON.parse(localStorage.getItem("authority"));
    if (data.roles.includes("SUPPLIER_ADMIN")) {
      getInvitations(0, itemsPerPage, sortField);
    }
  }, []);
  const handleSort = (val) => {
    if (sortField === val && order === "asc") {
      setOrder("desc");
    } else {
      setOrder("asc");
    }
    setSortField(val);
    getInvitations(0, itemsPerPage, val);
  };
  const getInvitations = (pageNumber, itemsPerPageVal, sortField) => {
    if (pageNumber > 0) {
      pageNumber = pageNumber - 1;
    } else {
      setCurrentPage(1);
    }
    if (itemsPerPageVal > 0) {
      var perPage = itemsPerPageVal;
    } else {
      var perPage = itemsPerPage;
    }
    var sort = sortField + "," + order;
    InvitationService.getPendingInvitations(pageNumber, perPage, sort)
      .then((response) => {
        let totalPages = parseFloat(response.headers["x-total-count"]);
        setItemTotalCount(totalPages);
        SetInvitations([...response.data]);
      })
      .catch((error) => {
        //ErrorHandlingService.handleError(error.response.status);
      });
  };
  const handleInvitation = (item, type) => {
    setSelItem(item);
    if (type === "Ignore") {
      setShowConfirmation(true);
    } else if (type === "Accept") {
      InvitationService.verifyInvitation(item.activationKey)
        .then((response) => {
          navigate(
            "/company_admin/supplier_details_onboard/" +
            item?.inviter?.id +
            "/" +
            response?.data?.supplierDetailsId
          );
        })
        .catch((error) => {
        });

    }
  };
  const callbackIgnore = (val) => {
    setShowConfirmation(false);
    if (val) {
      InvitationService.resendInvitation(selItem.id, "REJECTED")
        .then((response) => {
          if (response.status === 200) {
            toast.success("Success", {
              position: toast.POSITION.TOP_RIGHT,
            });
            getInvitations(0, itemsPerPage, sortField);
          }
        })
        .catch((error) => { });
    }
  };
  return (
    <div className="PendingInvitations">
      {/* <div className="List_header">
    <Breadcrumb className='h5'>
      <Breadcrumb.Item href="#">Home</Breadcrumb.Item>
      <Breadcrumb.Item href="https://getbootstrap.com/docs/4.0/components/breadcrumb/">
      Invitation
      </Breadcrumb.Item>
      
    </Breadcrumb>
    
    </div> */}

      <div className="List_header">
        <h5 className="MH">{t("PendingInvitations.label")}</h5>
      </div>

      <div className="List_Table_01">
        <div className="List_table-card01_head">
          <div>{/* <h6>New</h6> */}</div>
          <div className="List_table-card01_sort">
            <ul>
              <li className="filter">
                <Link to="#">
                  <button className="btn btn-secondary"><CgSortAz /> {t("Filter.label")}</button>
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="card List_table-card01">
          <Table responsive="sm">
            <thead>
              <tr>
                <th>{t("Company.label")}</th>
                <th>{t("Contact.label")}</th>
                <th>{t("CreatedDate.label")}</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {invitations.length > 0 ? (
                invitations?.map((item) => (
                  <tr key={item.id}>
                    <td>
                      {/* <div className="T_invitation_inner_03"> */}
                      <div>
                        {/* <div className='TI_03_icon'>
                    <img src={Logo} />
                  </div> */}

                        <h6 className="m-0">{item?.inviter?.legalName}</h6>

                        <p className="m-0">{/* {item.address} */}</p>
                      </div>
                    </td>
                    <td>
                      <div>
                        {" "}
                        {`+${item?.contactNumber?.code?.phoneCode} ${item?.contactNumber?.number} `}
                      </div>
                      <div>{item?.email}</div>
                    </td>
                    <td>{moment(item?.invitedOn).format("MMM DD, YYYY")}</td>
                    <td className="text-end">
                      <button
                        className="btn btn-secondary me-2"
                        onClick={() => handleInvitation(item, "Ignore")}
                      >
                        {t("Ignore.label")}
                      </button>
                      <button
                        className="btn btn-primary"
                        onClick={() => handleInvitation(item, "Accept")}
                      >
                        {t("Accept.label")}
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="4" className="text-center">
                    <div className="Nodatafound_box">
                      <h6><FcFinePrint className="me-2" /> {t("Nodatafound.label")}</h6>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
          <div className="p-2 List_footer_count">
            <Pagination
              itemsTotalCount={itemsTotalCount}
              itemsPerPage={itemsPerPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              alwaysShown={true}
              setItemsPerPage={setItemsPerPage}
              pageClicked={(pageNum, perPage) => {
                getInvitations(pageNum, perPage, sortField);
              }}
            />
          </div>
        </div>
      </div>
      {showConfirmation && (
        <ConfirmationModal
          modalShow={true}
          messageText={messageConfirmation}
          callbackModal={callbackIgnore}
          confirmBtn={t("Confirm.label")}
          CancelBtn={t("Cancel.label")}
        />
      )}
    </div>
  );
};

export default withTranslation()(PendingInvitations);
